/* eslint-disable @typescript-eslint/consistent-type-definitions */
import MUIAppBar, { AppBarProps as MUIAppBarProps } from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';

import AreaSelect from './area-select';
import CompanySelect from './company-select';
import DocsSelect from './docs-select';
import LanguageSwitcher from './language-switcher';
import SystemTime from './system-time';
import { useCompanyId } from '../../contexts/CompaniesAreasContext';

type TAppBarProps = MUIAppBarProps & {
  open?: boolean;
};

const StyledAppBar: React.ComponentType<TAppBarProps> = styled(MUIAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<TAppBarProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'end',
  alignItems: 'center',
  position: 'sticky',
  '& .fi': {
    width: '1.1em',
  },
  zIndex: 1099,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

function AppBar(): JSX.Element {
  const { companyId } = useCompanyId();

  return (
    <StyledAppBar>
      <Box>
        <Toolbar>
          <Box sx={{ display: 'flex', columnGap: '20px', alignItems: 'center', mt: '2px' }}>
            <CompanySelect />
            {companyId && companyId.id !== 'ALL' && <AreaSelect />}
            <SystemTime />
            <LanguageSwitcher type="app" />
            <DocsSelect />
          </Box>
        </Toolbar>
      </Box>
    </StyledAppBar>
  );
}

export default AppBar;
